import ItemFilter, { type FilterOption } from './ItemFilter';

export type TeamVelocityTeamFilterValue = string;

export default class TeamVelocityTeamFilter extends ItemFilter<TeamVelocityTeamFilterValue> {
  constructor({
    initialItems = [],
    initialOptions = [],
  }: {
    initialItems?: TeamVelocityTeamFilterValue[];
    initialOptions?: FilterOption<TeamVelocityTeamFilterValue>[];
  } = {}) {
    super(initialItems, initialOptions);
  }

  updateTeamOptions(teams: Array<{ id: string; name: string }>) {
    const options: FilterOption<TeamVelocityTeamFilterValue>[] = teams.map(
      team => ({
        text: team.name,
        value: team.id,
        label: team.name,
      })
    );
    this.setOptions(options);
  }
}
